import { CSVRow, Entity, FieldType, validate } from 'gossamer-unified';
import { TaskDefinition } from 'gossamer-model';

export interface InstitutionGroupMemberUploadRow {
  email_address: string;
  registration_task_definition_id?: number;
}

export const InstitutionGroupMemberUpload: Entity<InstitutionGroupMemberUploadRow> = {
  id: 'InstitutionGroupMemberUpload',
  title: 'Institution Group Member Upload',
  service: 'main',
  rowLabel: (row: InstitutionGroupMemberUploadRow) => row.email_address,
  primaryKeyFields: [],
  security: [],
  fields: {
    email_address: {
      seq: 5,
      type: FieldType.Text,
      label: 'Email Address',
      mandatory: true,
      listColumn: true,
    },
    registration_task_definition_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Registration Task Definition',
      refEntity: TaskDefinition,
      listColumn: true,
      description:
        'Optionally specify a task definition to be assigned to the user upon registration. This can be used to automatically trigger onboarding tasks for new group members.',
    },
  },
};

export const institutionGroupMemberValidator = (row: CSVRow<InstitutionGroupMemberUploadRow>): string[] => {
  const out: string[] = [];
  const rowValues = row as Record<string, unknown>;
  Object.keys(InstitutionGroupMemberUpload.fields).forEach((fieldId) => {
    const field = InstitutionGroupMemberUpload.fields[fieldId as keyof InstitutionGroupMemberUploadRow];
    const stdValidation = validate(field, rowValues[fieldId] as string | number | boolean | null | undefined);
    if (stdValidation) {
      out.push(`${field.label}: '${rowValues[fieldId] || ''}' ${stdValidation}`);
    }
  });
  if ((row.email_address || '').indexOf('@') === -1) {
    out.push(`Email Address: '${row.email_address}' is invalid`);
  }
  return out;
};
